import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  BASE_URL,
  getToken,
  getCurrentLanguage,
} from "../../shared/utils.js/utils";
import { makeOfflineRequest } from "../../shared/utils.js/offlineRequestManager";

// Get positions
export const getPositions = createAsyncThunk(
  "position/getPositions",
  async (_, { rejectWithValue }) => {
    try {
      const response = await makeOfflineRequest(`/positions`, "GET");
      return response;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "Failed to get positions!";
      return rejectWithValue({ message });
    }
  },
);

export const addPosition = createAsyncThunk(
  "position/addPosition",
  async ({ positionData, language }, { rejectWithValue }) => {
    try {
      const token = getToken();

      const currentLang = language || getCurrentLanguage();

      if (!token) {
        throw new Error("No authentication token found");
      }

      const response = await axios.post(`${BASE_URL}/positions`, positionData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response?.data?.errors) {
        const errors = error.response.data.errors;
        let errorMessage = "";

        Object.keys(errors).forEach(key => {
          if (Array.isArray(errors[key])) {
            errorMessage += errors[key].join(", ") + " ";
          } else {
            errorMessage += errors[key] + " ";
          }
        });

        return rejectWithValue({
          message: errorMessage.trim() || "Validation failed!",
          errors: error.response.data.errors,
        });
      }

      const message =
        error.response?.data?.message || "Failed to add position!";
      return rejectWithValue({ message });
    }
  },
);
